import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FormTranslationsProvider } from '../-components/form-translations-provider';

export const Route = createFileRoute('/old')({
	component: RouteComponent,
});

function RouteComponent() {
	// Request-scoped Lingui instance from router context — see $portalId/route.tsx.
	const { i18n } = Route.useRouteContext();
	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<Outlet />
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
